<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useNavigationStore from '../../stores/navigation';
import PageNavigationItem from './PageNavigationItem.vue';
import useLocale from '../../composables/useLocale';
import type { GoToItem } from '../../types';

type Emits = {
  (e: 'goToContent', item: GoToItem): void;
};
const emit = defineEmits<Emits>();

type Props = {
  search: string;
};
const props = defineProps<Props>();

const { t } = useLocale();
const { pages } = storeToRefs(useNavigationStore());

const filteredItems = computed(() => {
  const query = props.search.toLowerCase().replace('page', '').trim();
  if (!query) return pages.value;
  return pages.value.filter((p) => p.page.toString().includes(query));
});
</script>

<template>
  <v-sheet data-testid="bp-pages-tab">
    <v-list v-if="filteredItems.length">
      <v-virtual-scroll :items="filteredItems" renderless>
        <template #default="{ item, itemRef }">
          <PageNavigationItem :ref="itemRef" :item="item" @goToContent="emit('goToContent', $event)" />
        </template>
      </v-virtual-scroll>
    </v-list>
    <p v-else class="text-center pa-4">{{ t('book_player.message_no_items') }}</p>
  </v-sheet>
</template>
